import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiList = (): Partial<Components> => ({
  MuiList: {
    styleOverrides: {
      root: {
        padding: '0',
      },
    },
  },
});

export const MuiMenuItem = (baseTheme: Theme): Partial<Components> => ({
  MuiMenuItem: {
    styleOverrides: {
      root: {
        minHeight: '42px',
        fontSize: '0.875rem',
        padding: '12px 12px',
        '&.MuiMenuItem-root.Mui-selected': {
          fontWeight: 'bold',
          backgroundColor: baseTheme.palette.brand.lighter,
        },
        '&.MuiMenuItem-root:hover': {
          backgroundColor: baseTheme.palette.brand.lighter,
        },
      },
    },
  },
});
